import { ReactComponent as BankIcon } from 'asset/CustomIcons/bank.svg';
import { ReactComponent as DigitalLock } from 'asset/CustomIcons/digital-lock-gray.svg';
import { ReactComponent as Identity } from 'asset/CustomIcons/identity-gray.svg';
import { ReactComponent as PassportIcon } from 'asset/CustomIcons/passport.svg';
import { ReactComponent as QuickProcess } from 'asset/CustomIcons/quick-process-gray.svg';
import { ReactComponent as QuizIcon } from 'asset/CustomIcons/quiz.svg';
import { ReactComponent as SecureShield } from 'asset/CustomIcons/secure-shield-gray.svg';

export const SCREEN_WIDTH = 414;
export const SCREEN_HEIGHT = 920;

// The editor design's 249.27 x 553.93 screens are this frame at 0.602.
export const EDITOR_PREVIEW_SCALE = 0.602;

// The wizard and detail page render the same screens at 0.4 of the editor size.
export const WORKFLOW_PREVIEW_SCALE = 0.2408;

export const MEDALLION_PREVIEW_SCREENS = {
    CONSENT_SCREEN: 'consent',
    TWO_FACTOR_SCREEN: 'two-factor',
    VERIFICATION_SCREEN: 'verification',
    GOVT_ID_CAPTURE_SCREEN: 'govt-id-capture',
    KBA_QUIZ_SCREEN: 'kba-quiz',
    BANK_CONNECT_SCREEN: 'bank-connect',
    THANK_YOU_SCREEN: 'thank-you',
};

export const SCREEN_LABELS = {
    [MEDALLION_PREVIEW_SCREENS.CONSENT_SCREEN]: 'Consent',
    [MEDALLION_PREVIEW_SCREENS.TWO_FACTOR_SCREEN]: 'Start Verification',
    [MEDALLION_PREVIEW_SCREENS.VERIFICATION_SCREEN]: 'Identity Verification',
    [MEDALLION_PREVIEW_SCREENS.GOVT_ID_CAPTURE_SCREEN]: 'Government ID',
    [MEDALLION_PREVIEW_SCREENS.KBA_QUIZ_SCREEN]: 'Knowledge Quiz',
    [MEDALLION_PREVIEW_SCREENS.BANK_CONNECT_SCREEN]: 'Bank Connect',
    [MEDALLION_PREVIEW_SCREENS.THANK_YOU_SCREEN]: 'Thank You',
};

export const THANK_YOU_TITLE = 'You’re all done!';

export const BANK_CONNECT_COPY = {
    TITLE: 'Connecting to your bank…',
    SUB_TITLE: 'Setting up a secure connection. This may take a moment.',
};

export const GOVT_ID_COPY = {
    HEADER: 'Upload your government-issued ID',
    TITLE_WITH_PASSPORT:
        'Take a clear photo of the front of your ID card or the page of your passport with your photo.',
    TITLE_ID_ONLY: 'Take a clear photo of the front of your ID card.',
    ACCEPTED_DOCUMENTS: 'Accepted documents',
    ACCEPTED_DOCUMENTS_TOGGLE: 'Accepted Documents',
    TIPS_LINK: 'Unlock Pro Tips for a Perfect ID Capture!',
    CAPTURE: 'Capture',
    SESSION_INFO:
        'This session must be completed before time expires, or the session will need to be restarted.',
    SESSION_TIMER: '10 : 00',
};

export const PASSPORT_DOC_TYPE = 'PASSPORT';

export const US_COUNTRY_CODE = 'USA';

export const ALL_COUNTRIES = 'all';

export const PREVIEW_CHECKS = {
    TWO_FA: '2fa',
    RISK_SCORE: 'risk_score',
    GOVT_ID: 'govt_id',
    KBA: 'kba',
    BANK: 'bank',
    EDUCATION: 'education',
    EMPLOYMENT: 'employment',
    PROFESSIONAL_LICENSE: 'professional_license',
};

export const VERIFICATION_MODES = {
    SINGLE: 'SINGLE',
    AND: 'AND',
    OR: 'OR',
};

export const STEP_LABELS = {
    TWO_FA: '2FA',
    IDENTITY: 'Identity',
};

export const EEP_LABELS = {
    [PREVIEW_CHECKS.EDUCATION]: 'Education',
    [PREVIEW_CHECKS.EMPLOYMENT]: 'Employment',
    [PREVIEW_CHECKS.PROFESSIONAL_LICENSE]: 'Professional License',
};

export const CONSENT_TITLE = 'Identity Authentication';

export const TWO_FA_TITLE = 'Start Verification';

export const TWO_FA_DESCRIPTION =
    'Please confirm your e-mail & phone number below to proceed with Two Factor Authentication (2FA).';

export const TWO_FA_STEPS = [STEP_LABELS.TWO_FA, STEP_LABELS.IDENTITY];

export const TWO_FA_SUPPORT_LINK = 'Unable to update your contact information?';

export const VERIFICATION_TITLE = 'Identity Verification';

export const VERIFICATION_STEP = 'Verification 1 of 1';

export const VERIFICATION_DESCRIPTIONS = {
    [VERIFICATION_MODES.SINGLE]:
        'You will need to verify your identity using the method shown below',
    [VERIFICATION_MODES.AND]: (
        <>
            You will need to verify your identity using <strong>all</strong> methods shown below
        </>
    ),
    [VERIFICATION_MODES.OR]: (
        <>
            You will need to verify your Identity using <strong>any</strong> method shown below
        </>
    ),
};

export const KBA_TITLE = 'Knowledge Authentication Quiz';

export const KBA_TIMER = '5:00';

export const KBA_SUBMIT = 'Submit Answers';

export const KBA_QUESTIONS = [
    {
        id: 'street',
        question: 'Which of the following streets have you lived on?',
        options: ['Kingsley Avenue', 'Marlow Court', 'Beckford Lane', 'None of the above'],
        answer: 'Marlow Court',
    },
    {
        id: 'vehicle',
        question: 'Which of these vehicles have you owned or leased?',
        options: ['Toyota Corolla', 'Honda Civic', 'Subaru Outback', 'None of the above'],
        answer: null,
    },
];

export const VERIFICATION_CARDS = {
    [PREVIEW_CHECKS.GOVT_ID]: {
        icon: PassportIcon,
        title: 'Government Issued Document Proof',
    },
    [PREVIEW_CHECKS.KBA]: {
        icon: QuizIcon,
        title: 'Knowledge Authentication Quiz',
        subTitle: 'This option is only available to persons found in US commercial databases.',
    },
    [PREVIEW_CHECKS.BANK]: {
        icon: BankIcon,
        title: 'Financial Account Ownership',
        subTitle: 'This option is only available to persons with US financial accounts',
    },
};

export const CONSENT_VERIFIED_ICON = Identity;

export const CONSENT_INFO_ROWS = [
    {
        id: 'accuracy',
        icon: SecureShield,
        text: 'We use machine learning, computer vision, and AI for a forensic identity authentication.',
    },
    {
        id: 'privacy',
        icon: DigitalLock,
        text: (
            <>
                Your information will only be used by <span>Authenticate.com</span> for verification
                purposes.
            </>
        ),
    },
    {
        id: 'duration',
        icon: QuickProcess,
        text: 'This process takes only a couple of minutes.',
    },
];
